var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8596 26.7474H8.91579V8.91579H14.8596V11.8877C15.4854 11.0916 16.2795 10.4439 17.1851 9.99097C18.0908 9.53804 19.0854 9.29113 20.0977 9.26796C21.868 9.27779 23.5623 9.98928 24.8088 11.2464C26.0554 12.5036 26.7525 14.2037 26.7474 15.9741V26.7474H20.8035V16.7171C20.6885 15.914 20.2874 15.1795 19.6739 14.6488C19.0604 14.118 18.2758 13.8266 17.4645 13.8284C17.1015 13.8399 16.7444 13.9246 16.4149 14.0774C16.0854 14.2303 15.7901 14.4481 15.5468 14.7179C15.3035 14.9877 15.1173 15.3038 14.9992 15.6474C14.8811 15.9909 14.8336 16.3548 14.8596 16.7171V26.7474ZM5.94386 26.7474H0V8.91579H5.94386V26.7474ZM2.97193 5.94386C2.18372 5.94386 1.4278 5.63075 0.870458 5.0734C0.313113 4.51606 0 3.76013 0 2.97193C0 2.18372 0.313113 1.4278 0.870458 0.870458C1.4278 0.313113 2.18372 0 2.97193 0C3.76013 0 4.51606 0.313113 5.0734 0.870458C5.63075 1.4278 5.94386 2.18372 5.94386 2.97193C5.94386 3.76013 5.63075 4.51606 5.0734 5.0734C4.51606 5.63075 3.76013 5.94386 2.97193 5.94386Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLIcon);
export default __webpack_public_path__ + "static/media/l-icon.10877f5beb1a61b0a7c254f75ab64418.svg";
export { ForwardRef as ReactComponent };